import * as FormControl from '../utils/form-controls';
import * as CONST from '../utils/constants';

// global window
const filterObj = CONST.globalProject.Filters;
const filterDisplay = CONST.globalProject.FilterDisplay;

// initial state
// object name must match specification name
//specification, label, defaultValue, collapsible, expandDefault, groupType, subgroup, className
const filters = {
    Sector: new FormControl.FilterGroup('Sector', 'Filter by Sector', null, false, true, 'checkbox', undefined, '', 'group-types', filterDisplay.hideType || 'False'),
}; 


FormControl.assignFilters(filterObj, filters);

filters.Sector.subgroup.unshift(new FormControl.SelectOption('999', 'All Sector Types', true, false, false));

export { filters as default };